"use client";

import { SortDropdown } from "@/components/sort/SortDropdown";
import { MODEL_SORT_OPTIONS } from "@/constants/modelSortOptions";
import { useNamedSelectArtistFilters } from "@/lib/zustand/useSelectArtistFilters";

// Store-wired "Sort by" control, used by the desktop filter row and the mobile-only slot in RoyaltyFreeTab (sorting must reach every viewport).
export function SortArtists({
  namespace,
  listClassName,
  className,
}: {
  namespace: string;
  listClassName: string;
  className: string;
}) {
  const useSelectArtistFilters = useNamedSelectArtistFilters((state) =>
    state.getNamedStore(namespace)
  );
  const sortVariant = useSelectArtistFilters((state) => state.sortVariant);
  const setSortVariant = useSelectArtistFilters(
    (state) => state.setSortVariant
  );

  return (
    <SortDropdown
      label="SORT BY"
      value={sortVariant}
      options={MODEL_SORT_OPTIONS}
      onChange={setSortVariant}
      listClassName={listClassName}
      className={className}
    />
  );
}
